import { render, staticRenderFns } from "./comp_ProductPage-Tags.vue?vue&type=template&id=68737337"
import script from "./comp_ProductPage-Tags.vue?vue&type=script&lang=js"
export * from "./comp_ProductPage-Tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports